import { moduleProviderFactory } from "core/providers";
import { NikoInsuranceCoverageStatusOverviewEmailEdit } from "application/niko-insurance-coverage-status-overview/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
                    {
                        name: "master.app.main.facility-order.niko-overview.edit-email",
                        pattern: "/:facilityOrderId/email",
                        component: NikoInsuranceCoverageStatusOverviewEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.TEMPLATES",
                                    route: 'master.app.main.facility-order.facility-order-template.list'
                                },
                                {
                                    title: "INSURANCE_COVERAGE_STATUS_OVERVIEW.TITLE",
                                    route: 'master.app.main.facility-order.niko-overview.edit-email'
                                }
                            ]
                        }
                    },                 
                ]
            }
        ],
        menu: [
            {
                title: "MENU.FACILITY_ORDERS",
                icon: "package",
                authorization: "coreUserSection.read",
                order: 5,
                subMenu: [
                    {
                        title: "MENU.NIKO_FACILITY_ORDERS",
                        authorization: "administrationSection.read",
                        route: "master.app.main.niko-facility-order.list",
                        order: 3,
                    }
                ]
            },
        ]
    });
})();
